// authentication
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';
// messages
export const SET_MESSAGE = 'SET_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
// profile
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAIL = 'GET_PROFILE_FAIL';
// my Routines + home
export const GET_ROUTINE_SUCCESS = 'GET_ROUTINE_SUCCESS';
export const GET_ROUTINE_FAIL = 'GET_ROUTINE_FAIL';
export const GET_ROUTINES_SUCCESS = 'GET_ROUTINES_SUCCESS';
export const GET_ROUTINES_FAIL = 'GET_ROUTINES_FAIL';
// Tasks
export const GET_TASK_SUCCESS = 'GET_TASK_SUCCESS';
export const GET_TASK_FAIL = 'GET_TASK_FAIL';
export const SET_TASK_SUCCESS = 'SET_TASK_SUCCESS';
export const SET_TASK_FAIL = 'SET_TASK_FAIL';
export const GET_ROUTINES_TASK_SUCCESS = 'GET_ROUTINES_TASK_SUCCESS';
export const GET_ROUTINES_TASK_FAIL = 'GET_ROUTINES_TASK_FAIL';
export const CLEAR_EDIT_TASK_STATE = 'CLEAR_EDIT_TASK_STATE';
export const DELETE_TASK_SUCCESS = 'DELETE_TASK_SUCCESS';
export const DELETE_TASK_FAIL = 'DELETE_TASK_FAIL';
// measurements
export const GET_MEASUREMENT_SUCCESS = 'GET_MEASUREMENT_SUCCESS';
export const GET_MEASUREMENT_FAIL = 'GET_MEASUREMENT_FAIL';
export const SET_MEASUREMENT_SUCCESS = 'SET_MEASUREMENT_SUCCESS';
export const SET_MEASUREMENT_FAIL = 'SET_MEASUREMENT_FAIL';
export const GET_TASKS_MEASUREMENT_SUCCESS = 'GET_TASKS_MEASUREMENT_SUCCESS';
export const GET_TASKS_MEASUREMENT_FAIL = 'GET_TASKS_MEASUREMENT_FAIL';
export const CLEAR_EDIT_MEASUREMENT_STATE = 'CLEAR_EDIT_MEASUREMENT_STATE';
// admin
export const SET_ROUTINE_SUCCESS = 'SET_ROUTINE_SUCCESS';
export const SET_ROUTINE_FAIL = 'SET_ROUTINE_FAIL';
export const CLEAR_EDIT_ROUTINE_STATE = 'CLEAR_EDIT_ROUTINE_STATE';
export const DELETE_ROUTINE_SUCCESS = 'DELETE_ROUTINE_SUCCESS';
export const DELETE_ROUTINE_FAIL = 'DELETE_ROUTINE_FAIL';
